/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class FooterMessageBox
 * @hideconstructor
 * @classdesc API class that is used for FooterMessageBox
 */
define(() => {
	class FooterMessageBox {
		/**
		 * @function FooterMessageBox#setMessage
		 * @description render with the messages (messagePain + messageInBold) if the property showFooter is not false
		 * @param {string} messagePain - messagePainFormat
		 * @param {string} messageInBold - messageInBold
		 */
		setMessage() {}
	}
	return FooterMessageBox;
});
